import * as constants from './actions';

const initialState = {
    isSubmitting: false,
    isEmailMessageChanged: false,
    address: {}
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.EMAIL_SUCCESS:
            return {
                ...state,
                completeEmail: payload,
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier],
                recipientMask: payload.recipientMask
            };
        case constants.SET_SUCCESS_INFO:
            return {
                ...state,
                successInfo: {
                    repsEmailed: payload.repsEmailed || [],
                    id: payload.apiRequestData ? payload.apiRequestData.id : ''
                }
            };
        case constants.EMAIL_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.ON_EMAIL_MESSAGE_CHANGE:
            return {
                ...state,
                isEmailMessageChanged: true
            };
        case constants.ON_GO_TO_STEP2:
            return {
                ...state,
                topic: payload.topic,
                message: payload.message
            };
        case constants.ON_BACK_FROM_STEP2:
            return {
                ...state,
                backButtonClicked: payload
            };
        case constants.EMAIL_SUBMITTING_ERROR:
            return {
                ...state,
                emailSubmitError: payload
            };
        case constants.SET_PREFIX_POPUP_VISIBILITY:
            return {
                ...state,
                prefixModalVisible: payload
            };
        default:
            return state;
    }
}
